import { render, staticRenderFns } from "./defaultChat.vue?vue&type=template&id=8de98064&"
import script from "./defaultChat.vue?vue&type=script&lang=js&"
export * from "./defaultChat.vue?vue&type=script&lang=js&"
import style0 from "./defaultChat.vue?vue&type=style&index=0&id=8de98064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports